import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'address-lines',
  templateUrl: './address-lines.component.html',
  styleUrls: ['./address-lines.component.scss'],
})
export class AddressLinesComponent implements OnInit, OnDestroy {
  @Input() public addressFormGroup: UntypedFormGroup;
  @Input() public isShowErrors: boolean = true;
  @Input() public isShowRequired: boolean;
  public CUSTOM_MASK: any = CUSTOM_MASK;
  public errors: { [name: string]: IErrorForm };

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor() {}

  public ngOnInit(): void {
    this.errors = this.createErrors();

    this.addressFormGroup
      .get('line1')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: string) => {
        this.changeEditableAbility(!!value);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private createErrors(): { [name: string]: { [key: string]: string } } {
    return this.isShowErrors
      ? {
          address: {
            required: 'FORM_ERROR.REQUIRED',
            maxlength: 'FORM_ERROR.MAX_LENGTH',
          },
        }
      : {};
  }

  private changeEditableAbility(flag: boolean): void {
    const funcName: string = flag ? 'enable' : 'disable';
    this.addressFormGroup.get('line2')[funcName]();
    this.addressFormGroup.get('line3')[funcName]();
  }
}
